import { TabContext, TabPanel } from "@mui/lab";
import React, { useCallback, useEffect } from 'react';
import { EdgeAdjustmentsEnum, LayerTypeEnum } from "../enums";
import CustomTabList from "components/Common/CustomTabList";
import { Tab } from "@mui/material";
import { useTranslations } from "@fenetech/translations";
import { CADHelpers } from "../CADHelpers";
import CADOperationComponent from "./CADOperationComponent";
import { useCADActions, useCADState } from "../Context/CADContext";
import EdgeAdjustmentsComponent from "./EdgeTools/EdgeAdjustmentsComponent";
import useCADAvailableOperations from "../hooks/useCADAvailableOperations";
import { ICADLayer } from "../interfaces";
import GlassLayerSelection from "./GlassLayerSelection/GlassLayerSelection";

interface ICADOperationsTabsProps {

}

const CADOperationsTabs: React.FC<ICADOperationsTabsProps> = (props: ICADOperationsTabsProps) => {

    const cadActions = useCADActions();

    const handleTabChange = useCallback((event: React.SyntheticEvent, newValue: string) => {
        cadActions.setCurrentTab(newValue);
        cadActions.clearUIState();
    }, [cadActions]);

    const tm = useTranslations();
    const cadState = useCADState();

    const availableOperationTypes = useCADAvailableOperations(cadState.currentLayer);

    const layer: ICADLayer | null = cadState.currentLayer;
    const enabledTools = layer?.edgeAdjustmentTools ?? EdgeAdjustmentsEnum.None;

    useEffect(() => {

        //If the current tab isn't an available op type or is edgeadjustment but the layer doesn't support them, 
        // reset to the first available operation

        if (cadState.currentTab === "EdgeAdjustments") {
            if (enabledTools === EdgeAdjustmentsEnum.None) {
                cadActions.setCurrentTab(availableOperationTypes[0].toString());
            }
        } else {
            if (availableOperationTypes.length > 0 && !availableOperationTypes.includes(parseInt(cadState.currentTab))) {
                cadActions.setCurrentTab(availableOperationTypes[0].toString());
            }
        }
    }, [cadState.currentTab, availableOperationTypes, enabledTools]);

    if (!cadState.model || cadState.model.layer === null) return null;


    return <TabContext value={cadState.currentTab} >
        <GlassLayerSelection />

        <CustomTabList variant="scrollable" scrollButtons="auto" onChange={handleTabChange} sx={{ position: "sticky", top: "40px", zIndex: 40, maxWidth: "1000px" }}    >

            {availableOperationTypes.map((opType, index) => {

                const description = tm.Get(CADHelpers.OperationTypeDescriptionFromEnum(opType));

                return <Tab key={`TBL_${index}_${opType.toString()}`}
                    value={opType.toString()}
                    label={description}
                />

            })}

            {enabledTools > 0 && cadState.currentLayer?.layerType !== LayerTypeEnum.Grid &&
                <Tab key={`TBL_-1_EdgeAdjustments`} value="EdgeAdjustments" label={tm.Get("Edge Adjustments")} />
            }

        </CustomTabList>

        {availableOperationTypes.map((opType, index) => {
            return <TabPanel key={`TBPL_${index}_${opType.toString()}`} value={opType.toString()} sx={{ padding: 0, marginTop: 1 }}               >
                <CADOperationComponent operationType={opType} />
            </TabPanel>
        })}

        {enabledTools > 0 && layer &&
            <TabPanel key={`TBPL_-1_EdgeAdjustments`} value="EdgeAdjustments" sx={{ padding: 0, marginTop: 1 }} >
                <EdgeAdjustmentsComponent enabledAdjustments={enabledTools} />
            </TabPanel>
        }

    </TabContext>

}

export default CADOperationsTabs;
